import { gql } from '@urql/core';
import React from 'react';
import { useAppState } from '../../../client/providers/AppProvider';
import { Espin_Player_Profile, ParentChildSubscriptionsFragment } from '../../../generated/spin-graphql';
import { SubscriptionMyPlayerCard } from '../my-profile/parents/SubscriptionMyPlayerCard';

type Props = {
    players: ParentChildSubscriptionsFragment[];
};

gql`
    fragment ParentChildSubscriptions on espin_player_profile {
        subscription {
            id
        }
        ...SubscriptionMyPlayerCard
    }
`;

export const ParentSubscriptions: React.FC<Props> = ({ players }) => {
    const { user } = useAppState();

    const onUpgradeSubscription = (player: Espin_Player_Profile) => {
        console.log('upgrade me ' + player.spin_username);
    };

    const onManageSubscription = (player: Espin_Player_Profile) => {
        console.log('manage me ' + player.spin_username);
    };

    return (
        <div className="parent-subscriptions">
            {players &&
                players.map((player, index) => (
                    <SubscriptionMyPlayerCard
                        key={`subscription-my-player-card-${index}`}
                        player={player}
                        onClick={() => {
                            // for now, do nothing
                            // if (player.subscription) {
                            //     onManageSubscription(player);
                            // } else {
                            //     onUpgradeSubscription(player);
                            // }
                        }}
                    />
                ))}
        </div>
    );
};
